import { merge } from "lodash";
import addressModuleGetters from "./addressModule/getters";
import shipmentModuleGetters from "./shipmentModule/getters";

export default merge(addressModuleGetters, shipmentModuleGetters);
